/* global axios */
import ApiClient from './ApiClient';

class ProtocolsAPI extends ApiClient {
  constructor() {
    super('protocols', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // Steps
  getSteps(protocolId) {
    return axios.get(`${this.url}/${protocolId}/steps`);
  }

  updateStep(protocolId, stepId, data) {
    return axios.patch(`${this.url}/${protocolId}/steps/${stepId}`, data);
  }

  // Messages
  getMessages(protocolId) {
    return axios.get(`${this.url}/${protocolId}/messages`);
  }

  createMessage(protocolId, data) {
    return axios.post(`${this.url}/${protocolId}/messages`, data);
  }

  // Files
  getFiles(protocolId) {
    return axios.get(`${this.url}/${protocolId}/drive_files`);
  }

  uploadFile(protocolId, formData) {
    return axios.post(`${this.url}/${protocolId}/drive_files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteFile(protocolId, fileId) {
    return axios.delete(`${this.url}/${protocolId}/drive_files/${fileId}`);
  }

  // Transfer
  transfer(protocolId, data) {
    return axios.post(`${this.url}/${protocolId}/transfer`, data);
  }

  // Conversation Linking
  linkConversation(protocolId, conversationId) {
    return axios.post(`${this.url}/${protocolId}/link_conversation`, {
      conversation_id: conversationId,
    });
  }

  unlinkConversation(protocolId, conversationId) {
    return axios.post(`${this.url}/${protocolId}/unlink_conversation`, {
      conversation_id: conversationId,
    });
  }
}

export default new ProtocolsAPI();
